<template>
  <div v-editable="blok">
    <div class="page-mx module-pt module-pb">
      <div class="text-max-w mx-auto text-center clamp-mb-12-16">
        <span class="block text-body-sm opacity-80 clamp-mb-1-1">{{
          dateFormatted
        }}</span>
        <h1
          class="text-headline-sm"
          :style="{ 'font-weight': `var(--fw-headline-sm)` }">
          {{ blok.title }}
        </h1>
      </div>
      <div
        class="bg-white text-black clamp-max-w-260-310 mx-auto shadow-card card-rounded card-p"
        :class="[
          { 'clamp-py-3-24': !blok.media?.length },
          { 'clamp-pt-8-10 clamp-pb-8-24': blok.media?.length },
        ]">
        <div class="clamp-pb-8-16" v-if="blok.media?.length">
          <AImage
            :src="blok.media?.[0].image.filename"
            :alt="blok.media?.[0].image.alt"
            :focalPoint="blok.media?.[0].image.focus"
            :ratio="{ w: 2, h: 1 }"
            :sizes="[{ bpMin: '0', vw: 100 }]"
            class="clamp-rounded-2-2 w-full" />
        </div>
        <div class="tp:clamp-px-3-34">
          <ElementTexts :bloks="blok.texts" />
          <div
            v-if="blok.media?.length"
            class="flex flex-col clamp-gap-5-5 clamp-pt-10-16">
            <span
              class="text-body-md font-bold color-[--color] clamp-pt-6-6 border-t-1px"
              >Available media</span
            >
            <div class="grid grid-cols-12 clamp-gap-y-5-5 tp:clamp-gap-x-5-5">
              <ElementMediaGalleryCard
                :media="media"
                v-for="media in blok.media"
                class="col-span-12 tp:col-span-6 tl:col-span-4" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { TemplateArticleStoryblok } from "@/types";
import { useFormattedDate } from "@/composables/useDateFormatting";

interface Props {
  blok: TemplateArticleStoryblok;
}
const props = defineProps<Props>();

const dateFormatted = useFormattedDate(props.blok.date);
</script>
